import { useEffect, useState } from 'react';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleWhatsApp = () => {
    window.open('https://api.whatsapp.com/send/?phone=5492657618450&text=Hola%21+Me+gustar%C3%ADa+agendar+un+turno+en+Bonzo+Estilistas&type=phone_number&app_absent=0', '_blank');
  };

  return (
    <div className="bg-black text-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-black/95 backdrop-blur-md shadow-lg'}`}>
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 h-[60px] sm:h-[70px] flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/f4a443fe762ac8754619584d47ff6865/5f5b87633b4f0bcbe5483ef9f781732b.png" 
              alt="Bonzo Estilistas Logo" 
              className="h-10 sm:h-12 w-auto"
            />
          </div>
          
          <button 
            className="md:hidden text-white text-2xl cursor-pointer z-50"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menú"
          >
            <i className={mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>

          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('servicios')}
              className="text-gray-300 hover:text-white transition-colors text-sm font-medium tracking-wide cursor-pointer"
            >
              SERVICIOS
            </button>
            <button 
              onClick={() => scrollToSection('galeria')}
              className="text-gray-300 hover:text-white transition-colors text-sm font-medium tracking-wide cursor-pointer"
            >
              GALERÍA
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="text-gray-300 hover:text-white transition-colors text-sm font-medium tracking-wide cursor-pointer"
            >
              CONTACTO
            </button>
            <button 
              onClick={handleWhatsApp}
              className="bg-[#25D366] hover:bg-[#20BA5A] text-white px-6 py-2 transition-all duration-300 font-bold text-sm tracking-wide whitespace-nowrap flex items-center gap-2 cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-lg"></i>
              ESCRIBIR POR WHATSAPP
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-[60px] left-0 right-0 bg-black/98 backdrop-blur-md border-t border-gray-800">
            <div className="flex flex-col p-4 space-y-4">
              <button 
                onClick={() => scrollToSection('servicios')}
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium tracking-wide cursor-pointer text-left py-2"
              >
                SERVICIOS
              </button>
              <button 
                onClick={() => scrollToSection('galeria')}
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium tracking-wide cursor-pointer text-left py-2"
              >
                GALERÍA
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="text-gray-300 hover:text-white transition-colors text-sm font-medium tracking-wide cursor-pointer text-left py-2"
              >
                CONTACTO
              </button>
              <button 
                onClick={handleWhatsApp}
                className="bg-[#25D366] hover:bg-[#20BA5A] text-white px-6 py-3 transition-all duration-300 font-bold text-sm tracking-wide whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-lg"></i>
                ESCRIBIR POR WHATSAPP
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-[60px] sm:pt-0">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/c304271719f981a1f879c92a58c56843.png" 
            alt="Bonzo Estilistas Barbería" 
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
        </div>

        {/* Corner Decorations */}
        <div className="absolute top-4 left-4 sm:top-8 sm:left-8 w-12 h-12 sm:w-20 sm:h-20 border-l-2 border-t-2 border-[#333333]"></div>
        <div className="absolute top-4 right-4 sm:top-8 sm:right-8 w-12 h-12 sm:w-20 sm:h-20 border-r-2 border-t-2 border-[#333333]"></div>
        <div className="absolute bottom-4 left-4 sm:bottom-8 sm:left-8 w-12 h-12 sm:w-20 sm:h-20 border-l-2 border-b-2 border-[#333333]"></div>
        <div className="absolute bottom-4 right-4 sm:bottom-8 sm:right-8 w-12 h-12 sm:w-20 sm:h-20 border-r-2 border-b-2 border-[#333333]"></div>

        <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 w-full">
          <div className="max-w-3xl">
            <h1 className="text-5xl sm:text-7xl md:text-8xl font-black tracking-[0.1em] mb-3 sm:mb-4 text-white leading-tight">
              BONZO<br />ESTILISTAS
            </h1>
            <p className="text-xl sm:text-2xl md:text-3xl font-light text-gray-400 mb-4 sm:mb-6 tracking-wide">
              Desde 2007
            </p>
            <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
              <div className="w-12 sm:w-16 h-1 bg-[#8B0000]"></div>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-light text-gray-300 tracking-wide">
                Cortes y estilos con identidad
              </h2>
            </div>
            <p className="text-base sm:text-lg md:text-xl text-gray-400 italic mb-8 sm:mb-12 font-light">
              Un espacio donde el estilo no se copia, se construye.
            </p>
            <button 
              onClick={handleWhatsApp}
              className="inline-flex items-center gap-2 sm:gap-3 bg-[#25D366] hover:bg-[#20BA5A] text-white px-8 sm:px-12 py-4 sm:py-5 transition-all duration-300 font-bold text-base sm:text-lg tracking-wider whitespace-nowrap group cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl sm:text-2xl"></i>
              <span className="hidden sm:inline">ESCRIBIR POR WHATSAPP</span>
              <span className="sm:hidden">WHATSAPP</span>
            </button>
          </div>
        </div>
      </section>

      {/* Servicios Section */}
      <section id="servicios" className="bg-[#0A0A0A] py-16 sm:py-32">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
          <div className="mb-12 sm:mb-16 text-center">
            <div className="flex items-center justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
              <div className="w-1 h-12 sm:h-16 bg-[#8B0000]"></div>
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight">SERVICIOS</h2>
            </div>
            <p className="text-gray-400 text-lg sm:text-xl">Atención personalizada para hombres, mujeres y niños</p>
          </div>

          <div className="max-w-4xl mx-auto space-y-10 sm:space-y-12">
            {/* Cortes unisex */}
            <div className="border-l-4 border-[#8B0000] pl-6 sm:pl-8">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-white">
                Cortes unisex <span className="text-gray-500 text-lg sm:text-xl font-normal">(Hombres · Mujeres · Niños)</span>
              </h3>
              <p className="text-gray-400 text-base sm:text-lg mb-4 leading-relaxed">Tipos de corte disponibles:</p>
              <ul className="space-y-2 text-gray-300 text-base sm:text-lg ml-4">
                <li>– Corte a tijera</li>
                <li>– Corte a navaja</li>
                <li>– Corte a máquina</li>
              </ul>
              <p className="text-gray-400 text-sm sm:text-base mt-4 italic">
                Cada corte se adapta al estilo, edad y preferencia del cliente.
              </p>
            </div>

            {/* Color */}
            <div className="border-l-4 border-[#8B0000] pl-6 sm:pl-8">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-white">Color</h3>
              <ul className="space-y-2 text-gray-300 text-base sm:text-lg ml-4">
                <li>– Coloración completa</li>
                <li>– Retoques</li>
                <li>– Asesoramiento según tipo de cabello</li>
              </ul>
            </div>

            {/* Alisado */}
            <div className="border-l-4 border-[#8B0000] pl-6 sm:pl-8">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-white">Alisado</h3>
              <p className="text-gray-300 text-base sm:text-lg ml-4">
                – Tratamientos alisantes según necesidad del cabello
              </p>
            </div>

            {/* Permanente */}
            <div className="border-l-4 border-[#8B0000] pl-6 sm:pl-8">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-white">Permanente</h3>
              <p className="text-gray-300 text-base sm:text-lg ml-4">
                – Ondulación y definición con técnica profesional
              </p>
            </div>

            {/* Peinados */}
            <div className="border-l-4 border-[#8B0000] pl-6 sm:pl-8">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-white">Peinados</h3>
              <ul className="space-y-2 text-gray-300 text-base sm:text-lg ml-4">
                <li>– Peinados para eventos</li>
                <li>– Peinados diarios y especiales</li>
              </ul>
            </div>

            {/* Cauterizado */}
            <div className="border-l-4 border-[#8B0000] pl-6 sm:pl-8">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-white">Cauterizado</h3>
              <ul className="space-y-2 text-gray-300 text-base sm:text-lg ml-4">
                <li>– Reparación profunda</li>
                <li>– Recuperación de brillo y fuerza</li>
              </ul>
            </div>

            {/* Tratamientos capilares */}
            <div className="border-l-4 border-[#8B0000] pl-6 sm:pl-8">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-white">Tratamientos capilares</h3>
              <ul className="space-y-2 text-gray-300 text-base sm:text-lg ml-4">
                <li>– Hidratación</li>
                <li>– Nutrición</li>
                <li>– Cuidado del cabello dañado</li>
              </ul>
            </div>
          </div>

          <div className="text-center mt-12 sm:mt-16">
            <button 
              onClick={handleWhatsApp}
              className="inline-flex items-center gap-2 sm:gap-3 border-2 border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white px-6 sm:px-10 py-3 sm:py-4 transition-all duration-300 font-bold tracking-wider whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              <i className="ri-whatsapp-fill text-lg sm:text-xl"></i>
              CONSULTAR DISPONIBILIDAD
            </button>
          </div>
        </div>
      </section>

      {/* Por qué elegir Bonzo */}
      <section className="bg-[#151515] py-16 sm:py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
          <div className="mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-4 sm:mb-6 leading-tight">
              POR QUÉ ELEGIR<br />BONZO
            </h2>
            <div className="w-16 sm:w-20 h-1 bg-[#8B0000] mb-8 sm:mb-12"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-x-16 sm:gap-y-10">
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-user-heart-line text-[#8B0000] text-2xl sm:text-3xl flex-shrink-0"></i>
                <h3 className="text-lg sm:text-xl font-medium">Atención personalizada</h3>
              </div>
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-scissors-cut-line text-[#8B0000] text-2xl sm:text-3xl flex-shrink-0"></i>
                <h3 className="text-lg sm:text-xl font-medium">Estilo con identidad</h3>
              </div>
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-award-line text-[#8B0000] text-2xl sm:text-3xl flex-shrink-0"></i>
                <h3 className="text-lg sm:text-xl font-medium">19 años de trayectoria y experiencia real</h3>
              </div>
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-home-heart-line text-[#8B0000] text-2xl sm:text-3xl flex-shrink-0"></i>
                <h3 className="text-lg sm:text-xl font-medium">Ambiente auténtico</h3>
              </div>
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-repeat-line text-[#8B0000] text-2xl sm:text-3xl flex-shrink-0"></i>
                <h3 className="text-lg sm:text-xl font-medium">Clientes que vuelven</h3>
              </div>
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-shield-check-line text-[#8B0000] text-2xl sm:text-3xl flex-shrink-0"></i>
                <h3 className="text-lg sm:text-xl font-medium">Profesionalismo garantizado</h3>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            <div className="relative h-[400px] sm:h-[500px] md:h-[600px] overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/dc3a4644e56ba740789d70949d0cce34.jpeg" 
                alt="Ambiente Bonzo" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-radial from-transparent to-black/60"></div>
            </div>
            <div className="relative h-[400px] sm:h-[500px] md:h-[600px] overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/f4a443fe762ac8754619584d47ff6865/52feb3a22bcfb5d9938065ffcf6a3609.jpeg" 
                alt="Equipo Bonzo" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-radial from-transparent to-black/60"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Galería */}
      <section id="galeria" className="bg-black py-16 sm:py-24">
        <div className="text-center mb-12 sm:mb-16 px-4">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black mb-3 sm:mb-4">NUESTROS TRABAJOS</h2>
          <p className="text-gray-400 text-lg sm:text-xl italic">Cada corte habla por sí solo</p>
        </div>
        <div className="px-4 sm:px-6">
          <div className="columns-1 sm:columns-2 lg:columns-4 gap-3 sm:gap-5 max-w-[1600px] mx-auto">
            <div className="break-inside-avoid mb-3 sm:mb-5 relative group overflow-hidden cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/8b6b49cf003585be82b671b869476f66.jpeg" 
                alt="Trabajo 1" 
                className="w-full grayscale contrast-125 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#8B0000]/0 group-hover:bg-[#8B0000]/30 transition-all duration-300"></div>
            </div>
            <div className="break-inside-avoid mb-3 sm:mb-5 relative group overflow-hidden cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/45e70bb43ad639829eab713157970287.jpeg" 
                alt="Trabajo 2" 
                className="w-full grayscale contrast-125 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#8B0000]/0 group-hover:bg-[#8B0000]/30 transition-all duration-300"></div>
            </div>
            <div className="break-inside-avoid mb-3 sm:mb-5 relative group overflow-hidden cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/c0e94571b515b904f07adc4587591111.jpeg" 
                alt="Trabajo 3" 
                className="w-full grayscale contrast-125 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#8B0000]/0 group-hover:bg-[#8B0000]/30 transition-all duration-300"></div>
            </div>
            <div className="break-inside-avoid mb-3 sm:mb-5 relative group overflow-hidden cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/3a0fb697fbc8081e9241f2c633169f9c.jpeg" 
                alt="Trabajo 4" 
                className="w-full grayscale contrast-125 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#8B0000]/0 group-hover:bg-[#8B0000]/30 transition-all duration-300"></div>
            </div>
            <div className="break-inside-avoid mb-3 sm:mb-5 relative group overflow-hidden cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/114428c8814d62a34c99f470123575d4.png" 
                alt="Trabajo 5" 
                className="w-full grayscale contrast-125 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#8B0000]/0 group-hover:bg-[#8B0000]/30 transition-all duration-300"></div>
            </div>
            <div className="break-inside-avoid mb-3 sm:mb-5 relative group overflow-hidden cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/2d17b711d9aaed66ebd30b1c425fe8fd.jpeg" 
                alt="Trabajo 6" 
                className="w-full grayscale contrast-125 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#8B0000]/0 group-hover:bg-[#8B0000]/30 transition-all duration-300"></div>
            </div>
            <div className="break-inside-avoid mb-3 sm:mb-5 relative group overflow-hidden cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/312fcb143c5b4854da47e5291d9dfd72.png" 
                alt="Trabajo 7" 
                className="w-full grayscale contrast-125 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#8B0000]/0 group-hover:bg-[#8B0000]/30 transition-all duration-300"></div>
            </div>
            <div className="break-inside-avoid mb-3 sm:mb-5 relative group overflow-hidden cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/13cbcd373c37aaa2ae1bb2b7ea51a67a/f554ad6bb979db3db60d408cdea72a02.jpeg" 
                alt="Trabajo 8" 
                className="w-full grayscale contrast-125 group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#8B0000]/0 group-hover:bg-[#8B0000]/30 transition-all duration-300"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonios */}
      <section className="bg-[#1A1A1A] py-12 sm:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0 md:divide-x divide-[#8B0000]">
            <div className="px-4 sm:px-8 text-center">
              <i className="ri-double-quotes-l text-4xl sm:text-5xl text-[#8B0000] mb-3 sm:mb-4 block"></i>
              <p className="text-gray-300 text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed font-light">
                Excelente atención y estilo. Siempre vuelvo.
              </p>
              <p className="text-white font-bold text-sm">— Martín R.</p>
            </div>
            <div className="px-4 sm:px-8 text-center">
              <i className="ri-double-quotes-l text-4xl sm:text-5xl text-[#8B0000] mb-3 sm:mb-4 block"></i>
              <p className="text-gray-300 text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed font-light">
                Un lugar distinto en Villa Mercedes.
              </p>
              <p className="text-white font-bold text-sm">— Lucas G.</p>
            </div>
            <div className="px-4 sm:px-8 text-center">
              <i className="ri-double-quotes-l text-4xl sm:text-5xl text-[#8B0000] mb-3 sm:mb-4 block"></i>
              <p className="text-gray-300 text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed font-light">
                Profesionalismo y actitud en cada corte.
              </p>
              <p className="text-white font-bold text-sm">— Diego F.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ubicación y Contacto */}
      <section id="contacto" className="grid grid-cols-1 lg:grid-cols-2">
        <div className="h-[300px] sm:h-[400px] lg:h-auto relative order-2 lg:order-1">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6749.6!2d-65.4665981!3d-33.6870098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95d2ddc1e7c8b8b1%3A0x1234567890abcdef!2sBuenos%20Aires%20121%2C%20Villa%20Mercedes%2C%20San%20Luis!5e0!3m2!1ses!2sar!4v1234567890123!5m2!1ses!2sar&markers=color:red%7Clabel:1%7C-33.6870098,-65.4665981&markers=color:red%7Clabel:2%7C-33.6850098,-65.4645981"
            width="100%"
            height="100%"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ubicaciones Bonzo Estilistas"
            className="border-0"
          ></iframe>
        </div>
        <div className="bg-[#0A0A0A] p-6 sm:p-12 lg:p-16 flex flex-col justify-center order-1 lg:order-2">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-4 sm:mb-6">DÓNDE ESTAMOS</h2>
          <div className="w-16 sm:w-20 h-1 bg-[#8B0000] mb-8 sm:mb-12"></div>
          <div className="space-y-6 sm:space-y-8 mb-8 sm:mb-12">
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#8B0000] flex items-center justify-center flex-shrink-0 text-white font-bold text-sm sm:text-base">
                📌
              </div>
              <div>
                <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
                  Buenos Aires 121<br />Villa Mercedes, San Luis, Argentina
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 sm:gap-4">
              <i className="ri-time-line text-[#8B0000] text-2xl sm:text-3xl flex-shrink-0"></i>
              <div>
                <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
                  Consultar horarios disponibles
                </p>
              </div>
            </div>
          </div>
          <div className="mb-8 sm:mb-12">
            <p className="text-xs sm:text-sm text-gray-500 mb-3 sm:mb-4 tracking-wider">SEGUINOS</p>
            <a 
              href="https://www.instagram.com/bonzo_estilistas_villamercedes/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 sm:gap-3 text-white hover:text-[#8B0000] transition-colors text-xl sm:text-2xl cursor-pointer"
            >
              <i className="ri-instagram-line"></i>
              <span className="text-sm sm:text-base font-medium">@bonzo_estilistas_villamercedes</span>
            </a>
          </div>
          <button 
            onClick={handleWhatsApp}
            className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-[#25D366] hover:bg-[#20BA5A] text-white px-8 sm:px-12 py-4 sm:py-6 transition-all duration-300 font-bold text-base sm:text-xl tracking-wider whitespace-nowrap group cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-whatsapp-fill text-2xl sm:text-3xl"></i>
            <span className="hidden sm:inline">ESCRIBIR POR WHATSAPP</span>
            <span className="sm:hidden">WHATSAPP</span>
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-6 sm:py-8">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/f4a443fe762ac8754619584d47ff6865/5f5b87633b4f0bcbe5483ef9f781732b.png" 
              alt="Bonzo Logo" 
              className="h-6 sm:h-8 w-auto opacity-80"
            />
          </div>
          <p className="text-gray-600 text-xs sm:text-sm text-center">
            © 2025 Bonzo Estilistas - Villa Mercedes, San Luis
          </p>
          <div className="flex items-center gap-4">
            <a 
              href="https://www.instagram.com/bonzo.rockstyle/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-[#8B0000] transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-lg sm:text-xl"></i>
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-400 text-xs transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <button 
        onClick={handleWhatsApp}
        className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 z-50 animate-pulse cursor-pointer"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-fill text-white text-2xl sm:text-3xl"></i>
      </button>
    </div>
  );
}
